import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { createAppContainer } from "react-navigation";
import { createStackNavigator } from "react-navigation-stack";
import { Provider } from "react-redux";

import internationalizations from "./internationalizations";
import store from "./store";

import { changeIntroSlides } from "./actions/introSlides";
import { changeThemeColors } from "./actions/themeColors";
import {
  changeToken,
  changeFcmToken,
} from "./actions/token";
import { routeConfigMap, stackConfig } from "./screens";
import { setDevMode } from "./helpers/storage";

I18n.locale = "id";
I18n.translations = internationalizations;

const PrixaNavigator = createStackNavigator(routeConfigMap, stackConfig);

const PrixaContainer = createAppContainer(PrixaNavigator);

export default class Prixa extends React.Component {
  static defaultProps = {
    devMode: false,
    fcmToken: null,
    intent: null,
    introSlides: [],
    onClose: () => {},
    onDestinationChange: () => {},
    showIntro: true,
    themeColors: {},
  };

  static propTypes = {
    devMode: PropTypes.bool,
    fcmToken: PropTypes.string,
    intent: PropTypes.shape({
      action: PropTypes.string.isRequired,
    }),
    introSlides: PropTypes.array,
    onClose: PropTypes.func,
    onDestinationChange: PropTypes.func,
    showIntro: PropTypes.bool,
    themeColors: PropTypes.shape({
      darkerPrimary: PropTypes.string,
      darkestPrimary: PropTypes.string,
      lighterPrimary: PropTypes.string,
      lightestPrimary: PropTypes.string,
      primary: PropTypes.string,
    }),
    token: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    const {
      devMode,
      fcmToken,
      introSlides,
      showIntro,
      themeColors,
      token,
    } = this.props;

    setDevMode(devMode);

    store.dispatch(changeFcmToken(fcmToken));
    store.dispatch(changeThemeColors(themeColors));
    store.dispatch(changeToken(token));

    if (showIntro) {
      store.dispatch(changeIntroSlides(introSlides));
    }
  }

  handleNavigationStateChange = (_prevNavigationState, nextNavigationState) => {
    const { onDestinationChange } = this.props;

    const mapping = {
      Waiting: "Consultation",
    };

    const lastRoute = nextNavigationState.routes.slice(-1)[0];

    const destination = mapping[lastRoute.routeName] || "Other";

    onDestinationChange(destination);
  };

  render() {
    const { intent, onClose, onDestinationChange } = this.props;

    return (
      <Provider store={store}>
        <PrixaContainer
          onNavigationStateChange={this.handleNavigationStateChange}
          screenProps={{ intent, onClose, onDestinationChange }}
        />
      </Provider>
    );
  }
}
